import React from 'react';
import * as Icons from "react-icons/fa";
import '../../components/styles.css';

export default function Overview() {
    return (
      <div className='container-content-services'
        style={{
          backgroundColor:'gray',
          color:'black',
          border:'20px',
          padding:'20px',
		  	}}
		  >
        <div classNAme='main-content-box-1'  align='center'>
          <p-lg>
              Overview 
          </p-lg>
        </div>
        <div className='main-content-box-2'  align='left'>
          <p> <br></br>
              The Athelon Group is an affiliate marketing company that acts as a middleman, connecting businesses 
              (merchants) with individuals or other businesses (affiliates) whose purpose is to promote the 
              merchants' products or services. The company earns commissions for each sale or lead generated 
              through its unique affiliate link strategy. Essentially, we leverage our marketing skills and audience to 
              drive traffic and sales for the merchants we partner with, in exchange for a percentage of the revenue.
        </p>
          
        </div>
        <div className='main-content-box-3' align='center' >
              <p></p>
        </div>
      </div>
    )
  };

/*

*/